
export default function Partners() {
  const partners = [
    { name: 'Microsoft', icon: 'ri-microsoft-fill' },
    { name: 'Amazon AWS', icon: 'ri-amazon-fill' },
    { name: 'Google Cloud', icon: 'ri-google-fill' },
    { name: 'Oracle', icon: 'ri-database-2-line' },
    { name: 'SAP', icon: 'ri-bar-chart-box-line' },
    { name: 'Salesforce', icon: 'ri-cloud-line' },
    { name: 'IBM', icon: 'ri-server-line' },
    { name: 'Cisco', icon: 'ri-router-line' }
  ];

  return (
    <section id="partners" className="py-12 sm:py-20 px-4 sm:px-8 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-2xl sm:text-4xl font-bold text-[#1A2332] text-center mb-10 sm:mb-16">
          Strategic Technology Partners
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-12">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center p-4 sm:p-8 rounded-2xl hover:bg-gray-50 transition-all group cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl bg-gray-100 flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-[#0066CC] transition-all">
                <i className={`${partner.icon} text-2xl sm:text-3xl text-gray-400 group-hover:text-white transition-all`}></i>
              </div>
              <span className="text-xs sm:text-sm font-semibold text-gray-600 group-hover:text-[#0066CC] transition-all whitespace-nowrap">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
